import { DashboardModuleBaseAreaEnumActions, DashboardModuleBaseAreaState, DashboardModuleBaseAreaStateInfoWidget, initialDashboardModuleBaseAreaState } from '@/modules/dashboard-module/shared/components/base-area/dashboard-module-shared-components-base-area.model'
import { dashboardModuleSaveUIComponent } from '@/modules/dashboard-module/shared/models/dashboard-module.helpers'
import { DashboardModuleArea, dashboardModuleGridMaxCols, DashboardModuleLayoutWidget, DashboardModuleZoneAreaOptions } from '@/modules/dashboard-module/shared/models/dashboard-module.model'
import DashboardModuleSharedWidgetsNewCaseWidget from '@/modules/dashboard-module/shared/widgets/new-case-widget/dashboard-module-shared-widgets-new-case-widget.vue'
import DashboardModuleSharedWidgetsPendingWidget from '@/modules/dashboard-module/shared/widgets/pending-widget/dashboard-module-shared-widgets-pending-widget.vue'
import DashboardModuleSharedWidgetsPrintLabelsWidget from '@/modules/dashboard-module/shared/widgets/print-labels-widget/dashboard-module-shared-widgets-print-labels-widget.vue'
import { store } from '@/store/store'
import Vue from 'vue'
import Component from 'vue-class-component'
import { GridItem, GridItemData, GridLayout } from 'vue-grid-layout'
import { Prop } from 'vue-property-decorator/lib/decorators/Prop'
import { Ref } from 'vue-property-decorator/lib/decorators/Ref'

@Component({
    components: {
        DashboardModuleSharedWidgetsPendingWidget,
        DashboardModuleSharedWidgetsNewCaseWidget,
        DashboardModuleSharedWidgetsPrintLabelsWidget,
        GridLayout,
        GridItem
    }
})
export default class DashboardModuleBaseArea extends Vue {
    @Prop() readonly area!: DashboardModuleArea
    @Prop() readonly options!: DashboardModuleZoneAreaOptions
    @Ref() readonly gridLayout!: any

    state: DashboardModuleBaseAreaState
    constructor() {
        super()
        this.state = initialDashboardModuleBaseAreaState()
    }

    mounted(): void {
        this.state.unsubscribe = store.subscribeAction(async (action) => {
            switch (action.type) {
            case DashboardModuleBaseAreaEnumActions.DASHBOARD_ADD_WIDGET:
                if (action.payload.area === this.area) {
                    await this._addWidget(action.payload)
                }
                break
            case DashboardModuleBaseAreaEnumActions.DASHBOARD_REMOVE_WIDGET:
                if (action.payload.area === this.area) {
                    await this._removeWidget(action.payload)
                }
                break
            }
        })
    }

    get getLayout(): DashboardModuleBaseAreaStateInfoWidget[] {
        return this.state.widgets
    }

    get maxCols(): number {
        return dashboardModuleGridMaxCols
    }

    beforeDestroy() {
        this.state.unsubscribe()
    }

    async onMoveWidget(i: string, newX: number, newY: number): Promise<void> {
        await store.dispatch('dashboard/setCoordinatesWhenMoved', { i, newX, newY })
        await dashboardModuleSaveUIComponent()
    }

    private async _addWidget(widget: DashboardModuleLayoutWidget): Promise<void> {
        const auxWidget = widget
        const widgetToAdd: DashboardModuleBaseAreaStateInfoWidget = {
            ...this.getCoordinates(auxWidget),
            info: {
                ...auxWidget,
                coordinates: this.getCoordinates(auxWidget)
            }
        }
        this.state.widgets.push(widgetToAdd)
        await store.dispatch('dashboard/addWidgetToArea', widgetToAdd.info)
        if (!widget.coordinates) {
            await dashboardModuleSaveUIComponent()
        }
    }

    getCoordinates(widget: DashboardModuleLayoutWidget): GridItemData {
        const widthWidget = this.options.isWidgetFillToWidth ? dashboardModuleGridMaxCols : widget.width
        const heightWidget = this.options.isWidgetFillToHeight ? dashboardModuleGridMaxCols : widget.height
        const isWidgetFillToWidth = this.options.isWidgetFillToWidth ? 0 : (this.state.widgets.length * widthWidget) % (dashboardModuleGridMaxCols)
        return {
            i: widget.id,
            x: !widget.coordinates ? isWidgetFillToWidth : widget.coordinates.x,
            y: !widget.coordinates ? 0 : widget.coordinates.y,
            w: !widget.coordinates ? widthWidget : widget.coordinates.w,
            h: !widget.coordinates ? heightWidget : widget.coordinates.h
        }
    }

    private async _removeWidget(widget: DashboardModuleLayoutWidget): Promise<void> {
        const index = this.state.widgets.map((item: DashboardModuleBaseAreaStateInfoWidget) => item.i).indexOf(widget.id)
        this.state.widgets.splice(index, 1)
        await store.dispatch('dashboard/removeWidgetFromArea', widget)
        await dashboardModuleSaveUIComponent()
    }
}
